import { Link } from "react-router-dom";
import Logo from "../../assets/logo_header.svg";
import AISC from '../../assets/aisc.png';
import NISD from '../../assets/nisd.png';
import SDS from '../../assets/sds2_certification-badge__Detailer.png';

export const Footer = () => (
    <footer className="bg-navy-950 text-steel-300">
        <div className="container-px mx-auto max-w-7xl py-16">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-12">
                <div className="md:col-span-4 min-w-0">
                    <img src={Logo} alt="Rocky Point Detailing" className="h-10 w-auto max-w-full mb-5 block" />
                    <p className="text-sm leading-relaxed text-steel-400 mb-6 max-w-sm">
                        Structural and miscellaneous steel detailing for fabricators across the western U.S. — accurate shop drawings since 1993.
                    </p>
                    <div className="flex items-center gap-5">
                        <img src={AISC} alt="AISC" className="h-10 object-contain opacity-60 hover:opacity-100 transition-opacity" />
                        <img src={NISD} alt="NISD" className="h-10 object-contain opacity-60 hover:opacity-100 transition-opacity" />
                        <img src={SDS} alt="SDS2 Certified" className="h-10 object-contain opacity-60 hover:opacity-100 transition-opacity" />
                    </div>
                </div>

                <div className="md:col-span-2">
                    <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Company</h4>
                    <ul className="space-y-2.5 text-sm">
                        <li><Link to="/company" className="text-steel-400 hover:text-accent no-underline transition-colors">About</Link></li>
                        <li><Link to="/mission" className="text-steel-400 hover:text-accent no-underline transition-colors">Mission</Link></li>
                        <li><Link to="/services" className="text-steel-400 hover:text-accent no-underline transition-colors">Services</Link></li>
                        <li><Link to="/projects" className="text-steel-400 hover:text-accent no-underline transition-colors">Projects</Link></li>
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Services</h4>
                    <ul className="space-y-2.5 text-sm text-steel-400">
                        <li>Structural Steel Detailing</li>
                        <li>Miscellaneous Metals</li>
                        <li>BIM Management</li>
                        <li>Design-Assist & Delegated Design</li>
                    </ul>
                </div>

                <div className="md:col-span-3">
                    <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Contact</h4>
                    <ul className="space-y-2.5 text-sm">
                        <li className="text-steel-400">
                            1605 Palmales Ct.<br />Las Vegas, NV 89128
                        </li>
                        <li>
                            <a href="tel:8583242140" className="text-steel-400 hover:text-accent no-underline transition-colors">(858) 324-1903</a>
                        </li>
                        <li>
                            <a href="tel:7024308892" className="text-steel-400 hover:text-accent no-underline transition-colors">(702) 430-8892</a>
                        </li>
                        <li>
                            <a href="mailto:jim@rockypointdetailing.com" className="text-steel-400 hover:text-accent no-underline transition-colors break-all">jim@rockypointdetailing.com</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
                <p className="text-xs text-steel-500 m-0">
                    © {new Date().getFullYear()} Rocky Point Detailing LLC & Aircad LLC. All rights reserved.
                </p>
                <p className="text-xs text-steel-500 m-0">
                    Structural Steel Detailing · Since 1993
                </p>
            </div>
        </div>
    </footer>
);
